/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import Logo from 'assets/images/logo-conlicitacao-dark.png';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { useDispatch, useSelector } from 'react-redux';
import { invitation, invitationUpdate } from 'store/modules/profile_store/actions';
import * as S from './styles';

const Invitation = () => {
  const dispatch = useDispatch();
  const invitation_token = new URLSearchParams(window.location.search).get('invitation_token');
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const [formSubmitted, setFormSubmitted] = useState<boolean>(false);
  const [passwordNew, setPasswordNew] = useState<string>('');
  const [passwordConfirm, setPasswordConfirm] = useState<string>('');

  useEffect(() => {
    dispatch(invitation(invitation_token));
  }, []);

  const handleClick = () => {
    setFormSubmitted(true);

    if (passwordNew === passwordConfirm) {
      if (passwordNew.length >= 8 && /^(?=.*[a-zA-Z])(?=.*\d).+$/.test(passwordNew)) {
        dispatch(invitationUpdate(passwordNew, passwordConfirm, invitation_token));
      }
    }
  };

  useEffect(() => {
    const successMessages: { [key: string]: string } = {
      'Senha cadastrada com sucesso!': '/',
      'Recurso Expirado': '/usuarios/recurso_expirado',
    };

    const redirectPath = successMessages[profile?.message_success_password];

    if (redirectPath) {
      window.location.href = redirectPath;
    }
  }, [profile?.message_success_password]);

  return (
    <S.Body>
      <div className="login-bar text-white">
        <S.Container>
          <div className="row py-1">
            <div className="col-md-6 col-12">Tudo sobre licitações públicas</div>
            <div className="col-md-6 col-12 text-md-right text-left">
              {`Dúvidas? `}
              <a href="https://wa.me/5508001114133" target="_blank" rel="noopener noreferrer">
                Entre em contato
              </a>
              {` ou ligue 0800 11 14133`}
            </div>
          </div>
        </S.Container>
      </div>
      <div className="text-center my-3">
        <img src={Logo} alt="ConLicitação" className="my-3" style={{ width: '250px' }} />
      </div>
      <div className="row justify-content-center">
        <div className="col-md-4">
          <div className="card mt-1 p-5">
            <h5 className="text-center font-weight-bold">
              Olá {profile?.resource_name}, defina sua senha
            </h5>
            <div className="card-body">
              <div className="text-left">
                <label htmlFor="email">Email</label>
                <input
                  type="text"
                  className="form-control mt-1"
                  disabled
                  id="email"
                  value={profile?.resource_email}
                />
                <div className="alert alert-info mt-3" role="alert">
                  A senha deve ter no mínimo 8 caracteres, incluindo pelo menos uma letra e um
                  número.
                </div>
                <label htmlFor="email" className="mt-1">
                  * Nova senha
                </label>
                <input
                  type="password"
                  className="form-control mt-1"
                  id="password-new"
                  value={passwordNew}
                  onChange={(e) => setPasswordNew(e.target.value)}
                />
                {passwordNew.length > 0 && passwordNew.length < 8 && (
                  <p className="text-danger">Senha deve ter no mínimo 8 caracteres</p>
                )}
                {passwordNew.length >= 8 && !/(?=.*[a-zA-Z])(?=.*\d).+$/.test(passwordNew) && (
                  <p className="text-danger">Senha deve conter pelo menos uma letra e um número</p>
                )}
                <label htmlFor="email" className="mt-1">
                  * Confirme a nova senha
                </label>
                <input
                  type="password"
                  className="form-control mt-1"
                  id="password-confirm"
                  value={passwordConfirm}
                  onChange={(e) => setPasswordConfirm(e.target.value)}
                />
                {passwordNew !== passwordConfirm && formSubmitted && (
                  <p className="text-danger">As senhas não são iguais</p>
                )}
                <button
                  type="button"
                  className="btn btn-primary btn-lg btn-block my-3"
                  onClick={() => handleClick()}
                  disabled={!passwordNew || !passwordConfirm}
                >
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </S.Body>
  );
};
export default Invitation;
